import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import KeyFigures from "@/components/KeyFigures";
import QuoteForm from "@/components/QuoteForm";
import Testimonials from "@/components/Testimonials";
import CTABanner from "@/components/CTABanner";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import BackToTop from "@/components/BackToTop";

function App() {
  return (
    <div className="grain-overlay">
      <Header />
      <Hero />
      <Services />
      <KeyFigures />
      <QuoteForm />
      <Testimonials />
      <CTABanner />
      <Footer />
      <WhatsAppButton />
      <BackToTop />
    </div>
  );
}

export default App;
